<script>
import Vue from 'vue';
import { Message } from 'element-ui';

export default Vue.component('message', {
    methods: {
        message: Message
    }
});
</script>